<template>
  <div class="hero-breakout2">
    <div class="hero-inner">
      <img src="/assets/TANMLOGO2.PNG" alt="TANM Logo" class="hero-logo" />

      <h1>TANM – Takeaway Near Me</h1>
      <div class="location-cta">
        <LocationSearch />
      </div>
      <p class="tagline">
        Takeaway Near Me – Hungry? Find the best local food, fast. Discover new favourites, track orders in real-time, and enjoy exclusive offers from nearby restaurants.
      </p>



      <div class="launch-banner">
        We’re still building! <router-link to="/sign-up">Join the waitlist</router-link> or <router-link to="/vendor-signup">partner with us</router-link>.
      </div>
    </div>
  </div>
  <!-- Hero Section -->
  <div class="home-page">
    <!-- HERO -->
    <!-- Scroll Sections -->
    <div class="scroll-content">
      <section ref="wipSection" class="content section animated slide-in-right" v-scroll>
        <img src="/assets/wip.png" alt="Work in Progress" class="section-image" />
        <div class="text-content">
          <h2>Coming Soon</h2>
          <p>
            TANM is still in development. We're actively building the platform to bring you the best takeaway experience possible. New features will roll out regularly — stay tuned!
          </p>
          <router-link to="/about" class="btn">What We're Building</router-link>
        </div>
      </section>

      <section ref="section1" class="content section animated slide-in-left" v-scroll>
        <img src="/assets/searchFood.png" alt="Search Restaurants" class="section-image" />
        <div class="text-content">
          <h2>Find Nearby Takeaways</h2>
          <p>Browse local restaurants, search by cuisine or dish, and find exactly what you’re craving.</p>
          <router-link to="/search" class="btn">Start Browsing</router-link>
        </div>
      </section>

      <section ref="section2" class="content section animated slide-in-right" v-scroll>
        <img src="/assets/menuIcon.png" alt="Menu" class="section-image" />
        <div class="text-content">
          <h2>Customise Your Order</h2>
          <p>No onions? Extra spice? Add notes or personalise your dish before checkout.</p>
          <router-link to="/vendors" class="btn">Explore Menus</router-link>
        </div>
      </section>

      <section ref="section3" class="content section animated slide-in-left" v-scroll>
        <img src="/assets/onlinePayments.png" alt="Payments" class="section-image" />
        <div class="text-content">
          <h2>Secure Stripe Checkout</h2>
          <p>Pay easily with card, Apple Pay, or Google Pay using secure Stripe integration.</p>
          <router-link to="/vendors" class="btn">Try Checkout</router-link>
        </div>
      </section>
      </div>
      <section class="section full-width-section">
        <img src="/assets/searchFood.png" alt="Search Restaurants" class="section-image" />
        <div class="text-content">
          <h2>Find Nearby Takeaways</h2>
          <p>Browse local restaurants, search by cuisine or dish, and find exactly what you’re craving.</p>
          <a href="/search" class="btn">Start Browsing</a>
        </div>
      </section>
      <div class="scroll-content">
        <section ref="section4" class="content section animated slide-in-right" v-scroll>
          <img src="/assets/deliveryTracker.png" alt="Order Tracker" class="section-image" />
          <div class="text-content">
            <h2>Real-Time Order Tracking</h2>
            <p>See your order progress live – from confirmed to delivered, just like Domino’s.</p>
            <router-link to="/vendors" class="btn">Track an Order</router-link>
          </div>
        </section>

        <section ref="sectionVendor" class="content section animated slide-in-left" v-scroll>
          <img src="/assets/vendorIntegration.png" alt="Vendor Integration" class="section-image" />
          <div class="text-content">
            <h2>Vendor Website Integration</h2>
            <p>
              TANM is designed to easily integrate with vendor websites and systems. Whether you're a small independent takeaway or a fast-scaling brand, we'll offer tools to streamline menus, manage orders, and grow your customer base.
            </p>
            <router-link to="/about" class="btn">Learn More</router-link>
          </div>
        </section>


        <section ref="section5" class="content section animated slide-in-right" v-scroll>
          <img src="/assets/aboutTANM.png" alt="About TANM" class="section-image" />
          <div class="text-content">
            <h2>About TANM</h2>
            <p>We’re building a new kind of food ordering experience, focused on speed, transparency, and supporting local businesses.</p>
            <router-link to="/about" class="btn">Learn More</router-link>
          </div>
        </section>

        <section ref="section2" class="content section animated slide-in-left" v-scroll>
          <img src="/assets/signupIcon.png" alt="Menu" class="section-image" />
          <div class="text-content">
            <h2>Sign up to mailing list</h2>
            <p>Please sign up to our mailing list to be contacted when the site is ready.</p>
            <router-link to="/sign-up" class="btn">Learn More</router-link>
          </div>
        </section>
      </div>
    </div>

</template>

<script setup>
  import { LocationSearch } from 'shared-vue'
</script>
<script>
  export default {
    directives: {
      scroll: {
        mounted(el) {
          const handleScroll = () => {
            const position = el.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;
            if (position < windowHeight * 0.85) {
              if (el.classList.contains("slide-in-left")) {
                el.classList.add("animate-slide-in-left");
              } else {
                el.classList.add("animate-slide-in-right");
              }
              el.classList.add("show");
            }
          };
          window.addEventListener("scroll", handleScroll);
          handleScroll(); // Check on load

        }
      }
    }
  };

</script>

<style scoped>
  /* Hero Section */
  .hero {
    text-align: center;
    padding: 80px 20px;
    filter: drop-shadow(2px 4px 6px #00000033);
  }

  /* Scrollable Sections */
  .scroll-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 80px;
    padding: 50px 20px;
  }

  /* Section Layout */
  .section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    max-width: 900px;
    padding: 40px;
    border-radius: 10px;
    text-align: left;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s ease-out;
    flex-wrap: wrap;
  }

    /* Alternate Left & Right Layout */
    .section:nth-child(even) {
      flex-direction: row-reverse;
    }

  /* Image */
  .section-image {
    width: 150px;
    height: 150px;
    object-fit: contain;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.2);
    padding: 10px;
  }

  /* Text Content */
  .text-content {
    max-width: 500px;
  }

  /* Button */
  .btn {
    display: inline-block;
    padding: 10px 20px;
    margin-top: 10px;
    background: white;
    color: #333;
    font-weight: bold;
    text-decoration: none;
    border-radius: 5px;
    transition: background 0.3s ease;
  }

    .btn:hover {
      background: #ddd;
    }

  /* Slide-In Animations */
  .slide-in-left {
    transform: translateX(-50px);
  }

  .slide-in-right {
    transform: translateX(50px);
  }

  .animate-slide-in-left {
    transform: translateX(0);
    opacity: 1;
  }

  .animate-slide-in-right {
    transform: translateX(0);
    opacity: 1;
  }


  .home-hero {
    text-align: center;
    padding: 100px 20px 60px;
    color: white;
    max-width: 900px;
    margin: 0 auto;
  }

    .home-hero h1 {
      font-size: 42px;
      margin-bottom: 20px;
      font-weight: bold;
    }

    .home-hero p {
      font-size: 18px;
      margin-bottom: 30px;
      line-height: 1.6;
    }

  .cta-btn {
    margin-top: 20px;
    display: inline-block;
    background: #ffffff;
    color: #4a0060;
    font-weight: bold;
    font-size: 16px;
    padding: 14px 26px;
    border-radius: 8px;
    text-decoration: none;
    transition: background 0.3s ease;
  }

    .cta-btn:hover {
      background: #ddd;
    }

  .hero-background::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at center, rgba(0, 0, 0, 0.3), transparent);
    z-index: 0;
  }

  .status-banner {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    padding: 12px 20px;
    margin: 20px auto 0;
    text-align: center;
    border-radius: 8px;
    max-width: 900px;
    font-weight: bold;
  }

  .hero-wrapper {
    background: linear-gradient(to bottom, #4d0099 0%, #31005f 100%);
    padding: 100px 20px 60px;
    color: white;
    text-align: center;
    position: relative;
    z-index: 1;
  }

  .hero-inner {
    max-width: 900px;
    margin: 0 auto;
  }

    .hero-inner h1 {
      font-size: 42px;
      margin-bottom: 15px;
      font-weight: 700;
    }

  .tagline {
    font-size: 18px;
    line-height: 1.6;
    margin-bottom: 30px;
  }

  .location-cta {
    margin-bottom: 25px;
  }

  .launch-banner {
    background: rgba(255, 255, 255, 0.1);
    padding: 12px 20px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
  }

    .launch-banner a {
      color: #fff;
      font-weight: bold;
      text-decoration: underline;
    }


  .hero-breakout2 {
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -48vw;
    margin-right: -48vw;
    padding-bottom: 50px;
    width: 96vw;
    /*background: linear-gradient(to bottom, #4d0099cc, #31005f);
    background: linear-gradient( to bottom, #4d009900 0%, #4d009911 10%, #31005fcc 50%, #31005fcc 70%, #4d009900 100% );*/
    /*padding: 100px 20px 60px;*/
    text-align: center;
    color: white;
    z-index: 1;
  }

  .hero-breakout {
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    padding-bottom: 50px;
    width: 100vw;
    background: linear-gradient(to bottom, #4d0099, #31005f);
    padding: 100px 20px 60px;
    text-align: center;
    color: white;
    z-index: 1;
  }

  .hero-inner {
    max-width: 1400px;
    text-align: center;
    /*margin: 0 auto;
    padding: 40px;
    background: rgba(0, 0, 0, 0.35);
    border-radius: 16px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(6px);*/
  }
  .hero-logo {
    width: 90px;
    margin: 0 auto 20px;
    display: block;
    min-height:80px;
   /* border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);*/
  }


  @media (max-width: 1024px) {

    .hero-inner {
      padding: 5px;
    }
  }


  .full-width-section {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(90deg, #5a0ef5 0%, #8e2de2 100%);
    color: white;
    padding: 3rem 6vw;
    box-sizing: border-box;
    border-radius: 0; /* removes the card-like rounding */
    margin: 2rem 0;
    /* Remove any animation classes */
  }

    .full-width-section .section-image {
      max-width: 300px;
      height: auto;
      flex-shrink: 0;
    }

    .full-width-section .text-content {
      max-width: 600px;
    }

    .full-width-section h2 {
      font-size: 2rem;
      margin-bottom: 0.5rem;
    }

    .full-width-section p {
      font-size: 1.1rem;
      margin-bottom: 1rem;
    }

    .full-width-section .btn {
      background-color: white;
      color: #5a0ef5;
      font-weight: bold;
      padding: 0.75rem 1.5rem;
      border-radius: 8px;
      display: inline-block;
      text-decoration: none;
      transition: background-color 0.3s ease, color 0.3s ease;
    }

      .full-width-section .btn:hover {
        background-color: #f2f2f2;
        color: #4b00e0;
      }

  /* Responsive stacking for mobile */
  @media (max-width: 768px) {
    .full-width-section {
      flex-direction: column;
      text-align: center;
    }

      .full-width-section .section-image {
        max-width: 220px;
        margin-bottom: 1.5rem;
      }

      .full-width-section .text-content {
        max-width: 100%;
      }
  }

</style>
